import { MARQUEE_PHRASES } from "@/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {Array.from({ length: 4 }).map((_, r) =>
      MARQUEE_PHRASES.map((phrase, i) => (
        <span key={`${r}-${i}`} className="flex items-center">
          <span className="font-serif italic text-2xl md:text-3xl text-taupe/80 whitespace-nowrap px-8 md:px-12">
            {phrase}
          </span>
          <span className="h-1 w-1 rounded-full bg-teal/60" aria-hidden="true" />
        </span>
      ))
    )}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="overflow-hidden border-y border-stone/70 py-7 md:py-9 select-none"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
